export default {
   state: {
      showDialog: false,
      toLink: null,
   },
   actions: {
      showLeaveAlert: ({ commit }, { toLink }) => {
         const obj = {
            toLink: toLink,
         }
         commit('showLeaveAlert', obj);
      },
      closeLeaveAlert: ({ commit }) => {
         commit('closeLeaveAlert');
      }
   },
   mutations: {
      showLeaveAlert: (state, { toLink }) => {
         state.showDialog = true;
         state.toLink = toLink;
      },
      closeLeaveAlert: (state) => {
         state.showDialog = false;
      }
   },
}